import { animate, style, transition, trigger } from '@angular/animations';

import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { NxMessageModule } from '@allianz/ng-aquila/message';
import { MessageService } from '../../../shared/services/message.service';

@Component({
  selector: 'app-message',
  standalone: true,
  imports: [NxMessageModule],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  animations: [
    trigger('messageAnim', [
      transition(':enter', [
        style({ transform: 'translateY(100px)' }),
        animate('200ms ease', style({ transform: 'translateY(0px)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0px)' }),
        animate('200ms ease', style({ transform: 'translateY(100px)' })),
      ]),
    ]),
  ],
})
export class MessageComponent {
  // services
  readonly messageService = inject(MessageService);

  isArray = computed(() => typeof this.messageService.text() !== 'string');
}
